import React, { useEffect, useState } from 'react'
import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { formatAddress } from '../../util/format-data';
import { XCircleIcon } from '@heroicons/react/24/outline';
import { useNavigate } from 'react-router-dom';

import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Typography,
  Button,
  Chip,
  Avatar,
  IconButton,
  Tooltip,
  Slider,
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
  Spinner
} from "@material-tailwind/react";

import { useTranslation } from 'react-i18next';
import {
  useLocation
} from "react-router-dom";

export default function StampCard(props) {
  const { data, handle } = props;

  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [show, setShow] = useState(false);
  const location = useLocation();
  const [imageShow, setImageShow] = useState(false);
  const [srcDoc, setSrcDoc] = useState("");

  useEffect(() => {
    if (data.stamp_url.includes(".html")) {
      fetch(data.stamp_url)
      .then(response => response.text())
      .then(htmlContent => {
        setSrcDoc(htmlContent);
      })
      .catch(error => {
        console.error('Error fetching stamp HTML:', error);
      });
    }
  })

  const handleImageClick = () => {
    setImageShow(true);
  };

  const handleStampClick = () => {
    navigate(`/stamp/asset/${data.cpid}`)
  }

  return (
    <div className="border-borderColor border-[1px] border-solid bg-gray-900 p-3 rounded-md">
      {/* <iframe src={data.stamp_url} scrolling="no" sandbox="allow-scripts" loading="lazy" className="w-full sm:min-h-[256px] min-h-[150px] rounded-md" ></iframe> */}
      <div className="relative w-full sm:h-[200px] h-[140px]">
        {
          data.stamp_url.includes(".html") ? 
          <iframe 
            srcDoc={srcDoc}
            className="w-full h-full object-contain rounded-md cursor-pointer"
            onClick={() => handleImageClick(data.stamp_url)}
            sandbox="allow-scripts allow-same-origin"
          />
          :
          <img
            src={data.stamp_url}
            alt="Stamp"
            onClick={() => handleImageClick(data.stamp_url)}
            className="w-full h-full object-contain rounded-md image-rendering-pixelated cursor-pointer"
          />
        }
      </div>
      <div className="flex flex-row justify-between items-center">
        <div className="text-primary font-bold text-[20px] mt-1 cursor-pointer" onClick={handleStampClick}>Stamp {data.stamp}</div>
        <div className="w-[40px]text-[20px] rounded-md font-bold text-center cursor-pointer hover:border-primary hover:text-primary" onClick = {() => {setShow(true)}}>
          <InformationCircleIcon strokeWidth={2} className="h-6 w-6" />
        </div>
      </div>
      <div className="text-white mt-1 sm:w-[250px] w-[140px] truncate">{data.cpid}</div>
      <div className="text-white mt-1">{t('Amount')}: {data.balance}</div>
      {
        location.pathname.includes('/profile') ?
        <div className="flex flex-row w-full">
          <div onClick={() => handle(data)} className="rounded-md hover:text-primary hover:border-primary px-8 py-1 w-full font-bold mt-4 text-center text-white cursor-pointer border-[1px] border-solid border-white">{t('Trade')}</div>
        </div>
        : <></>
      }
      <Dialog
        open={imageShow}
        size={"md"}
        className="bg-black border-solid border-[1px] border-gray-600"
      >
        <DialogBody>
          <div className ="p-5 relative">
            {
              data.stamp_url.includes(".html") ? 
              <iframe 
                srcDoc={srcDoc}
                className="w-full h-full object-contain rounded-md cursor-pointer"
                sandbox="allow-scripts allow-same-origin"
              />
              :
              <img src={data.stamp_url} className = "w-full h-full object-contain rounded-md image-rendering-pixelated" alt="Enlarged" />
            }
            <XCircleIcon className = "absolute top-0 right-0 h-6 w-6 cursor-pointer" strokeWidth={2} onClick={() => {setImageShow(false)}}/>
          </div>
        </DialogBody>
      </Dialog>
      <Dialog
        open={show}
        size={"xs"}
        className="bg-black border-solid border-[1px] border-gray-600"
      >
        <DialogBody>
          <div className="flex flex-col justify-center w-full gap-3 p-3 sm:max-h-full max-h-[500px] overflow-y-auto">
            <div className="flex flex-row text-center justify-center items-center w-full text-primary gap-1">
              <InformationCircleIcon strokeWidth={2} className="h-12 w-12" />
              <span className="text-[32px] font-bold text-primary">{t('Details')}</span>
            </div>
            <div className="flex flex-row justify-between border-b-[1px] border-gray-900 pb-1">
              <div className="text-[#9a9790]">STAMP ID:</div>
              <div className="text-white">{data.stamp}</div>
            </div>
            <div className="flex flex-row justify-between border-b-[1px] border-gray-900 pb-1">
              <div className="text-[#9a9790]">CPID:</div>
              <div className="text-white">{data.cpid}</div>
            </div>
            <div className="flex flex-row justify-between border-b-[1px] border-gray-900 pb-1">
              <div className="text-[#9a9790]">{t('CREATOR')}:</div>
              <div className="text-white">{formatAddress(data.creator)}</div>
            </div>
            <div className="flex flex-row justify-between border-b-[1px] border-gray-900 pb-1">
              <div className="text-[#9a9790]">{t('SUPPLY')}:</div>
              <div className="text-white">{data.supply}</div>
            </div>
            <div className="flex flex-row justify-between border-b-[1px] border-gray-900 pb-1">
              <div className="text-[#9a9790]">{t('DIVISIBLE')}:</div>
              <div className="text-white">{data.divisible == 0 ? "FALSE" : "TRUE"}</div>
            </div>
            <div className="flex flex-row justify-between border-b-[1px] border-gray-900 pb-1">
              <div className="text-[#9a9790]">{t('LOCKED')}:</div>
              <div className="text-white">{data.locked == 0 ? "FALSE" : "TRUE"}</div>
            </div>
          </div>
          <div className="flex flex-row-reverse w-full mt-2">
            <Button  onClick={() => setShow(false)}>{t('RETURN')}</Button>
          </div>
        </DialogBody>
      </Dialog>
    </div>
  )
}
